if (!customElements.get('theme-gallery')) {
  class ThemeGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.galleryVideoList = Array.from(this.querySelectorAll('.gallery--item .gallery__video'));

      this.hoverPlayList = this.galleryVideoList.filter((item) => {
        return item.classList.contains('hover-play') && item;
      });

      this.autoPlayList = this.galleryVideoList.filter((item) => {
        return !item.classList.contains('hover-play') && item;
      });

      this.autoPlayList.forEach((item) => {
        item.querySelector('video').play();
      });

      this.setHoverPlayList();
      this.addMobileArrows(); // 🔥 NEW
    }

    setHoverPlayList() {
      this.hoverPlayList.forEach((item) => {
        item.querySelector('video').currentTime = 0.1;
        item.parentElement.addEventListener('mouseenter', () => this.playVideo(item));
        item.parentElement.addEventListener('mouseleave', () => this.pauseVideo(item));
      });
    }

    playVideo(videoContainer) {
      videoContainer.querySelector('video').play();
    }

    pauseVideo(videoContainer) {
      videoContainer.querySelector('video').pause();
    }

    addMobileArrows() {
      if (window.innerWidth > 768) return; // Only for mobile

      const galleryInner = this.querySelector('.gallery--inner');
      if (!galleryInner) return;

      const leftBtn = document.createElement('button');
      const rightBtn = document.createElement('button');

      leftBtn.innerHTML = '&#10094;';
      rightBtn.innerHTML = '&#10095;';
      leftBtn.className = 'mobile-gallery-arrow left';
      rightBtn.className = 'mobile-gallery-arrow right';

      this.appendChild(leftBtn);
      this.appendChild(rightBtn);

      const scrollAmount = galleryInner.offsetWidth * 0.8;

      leftBtn.addEventListener('click', () => {
        galleryInner.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      rightBtn.addEventListener('click', () => {
        galleryInner.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  }

  customElements.define('theme-gallery', ThemeGallery);
}
